import * as React from 'react';
import { FavouriteLayout } from 'app/area/favourite/components/favourite-layout';
import { FavouriteResult } from 'app/area/favourite/favourite-result';
import { FavouriteDefinition } from 'app/types-shared';
import { StatisticalReportExternalProps } from 'app/area/reports/types';
import { CaseReportExternalProps } from 'app/area/case-report/case-report-container';

interface FavouriteFiltersAndResultProps {
  hideFilters: boolean;
  isCreateReportOpen: boolean;
  updateExistingReport: boolean;
  initiallyOpenFilter: boolean;
  report: number;
  definition: FavouriteDefinition;
  workingDefinition: FavouriteDefinition;
  translation: any;
  getSearchRequiredUsers: () => void;
  onCloseReport: () => void;
  updateDefinition: (transform?: (definition: FavouriteDefinition) => FavouriteDefinition) => void;
  caseReportExternalProps?: CaseReportExternalProps;
  statisticalReportExternalProps?: StatisticalReportExternalProps;
  searchRequiredUsers: boolean;
  windowAsScrollableAncestor?: boolean;
}

export const FavouriteFiltersAndResult = ({
  hideFilters,
  isCreateReportOpen,
  updateExistingReport,
  onCloseReport,
  updateDefinition,
  initiallyOpenFilter,
  report,
  definition,
  workingDefinition,
  translation,
  getSearchRequiredUsers,
  caseReportExternalProps,
  statisticalReportExternalProps,
  searchRequiredUsers,
  windowAsScrollableAncestor
}: FavouriteFiltersAndResultProps) => {
  
  const result = <FavouriteResult
    report={report}
    definition={definition}
    workingDefinition={workingDefinition}
    updateDefinition={updateDefinition}
    caseReportExternalProps={caseReportExternalProps}
    statisticalReportExternalProps={statisticalReportExternalProps}
    windowAsScrollableAncestor={windowAsScrollableAncestor}
  />;

  if (hideFilters) {
    return result;
  }

  return <FavouriteLayout
      isCreateReportOpen={isCreateReportOpen}
      updateExistingReport={updateExistingReport}
      closeReportCreator={onCloseReport}
      updateDefinition={updateDefinition}
      initiallyOpenFilter={initiallyOpenFilter}
      definition={definition}
      translation={translation}
      getSearchRequiredUsers={getSearchRequiredUsers}
      searchRequiredUsers={searchRequiredUsers}
      hideFilters={hideFilters}>
      
    {result}
  </FavouriteLayout>;
};
